import { useWishlist } from '@/context/WishlistContext';
import styles from './WishButton.module.css';

/** Filled heart when saved. Stops propagation so it works on top of clickable cards. */
export function WishButton({ productId, productName, size = 'sm', floating = false }) {
  const { has, toggle } = useWishlist();
  const saved = has(productId);

  return (
    <button
      type="button"
      aria-pressed={saved}
      aria-label={saved ? `Remove ${productName} from wishlist` : `Save ${productName} to wishlist`}
      className={[styles.wish, styles[size], saved && styles.active, floating && styles.floating]
        .filter(Boolean)
        .join(' ')}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggle(productId);
      }}
    >
      <span aria-hidden="true">{saved ? '♥' : '♡'}</span>
    </button>
  );
}
